var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!_vm.loggedIn)?_c('h4',{staticClass:"alert alert-success"},[_vm._v("\n    Signed out successfully. Close this tab if you are finished working.\n    Click Home to sign in and continue working.\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }